// extracted by mini-css-extract-plugin
export default {"bodyNotMobile":"AccountBody_bodyNotMobile__Qu3Uz","bodyMobile":"AccountBody_bodyMobile__cdunj"};